/**
 * LIFF SDK 包裝
 *
 * 初始化流程：
 *   1. liff.init({ liffId })
 *   2. liff.isLoggedIn() ? continue : liff.login()
 *   3. liff.getAccessToken() + liff.getProfile()
 *   4. POST /api/auth/liff-verify → 拿 yannwo JWT
 *   5. JWT 存進 Zustand authStore，所有 API 都帶
 *
 * 後台（admin/*）不掛 LIFF SDK，獨立走 email/password login。
 */
import liff from "@line/liff";

const LIFF_ID = import.meta.env.VITE_LIFF_ID as string;

let _initialized = false;

export async function initLiff(): Promise<{
  userId: string;
  displayName: string;
  pictureUrl: string;
  accessToken: string;
} | null> {
  if (!LIFF_ID) {
    console.warn("[LIFF] VITE_LIFF_ID 未設定，跳過 LIFF init（dev mode）");
    return null;
  }
  if (!_initialized) {
    await liff.init({ liffId: LIFF_ID });
    _initialized = true;
  }
  if (!liff.isLoggedIn()) {
    liff.login();
    return null;
  }
  const accessToken = liff.getAccessToken() || "";
  const profile = await liff.getProfile();
  return {
    userId: profile.userId,
    displayName: profile.displayName,
    pictureUrl: profile.pictureUrl || "",
    accessToken,
  };
}

export function liffSdk() {
  return liff;
}
